<template>
  <dialogTemplate
    :openDialog="isOpen"
    :widthDialog="'700px'"
    :classDialog="'createDialog'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
  >
    <template #body>
      <h3 class="dialogTitle margin-left-0">
        Thêm mới phòng họp Mobimeeting cố định
      </h3>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-position="left"
        label-width="120px"
        :validate-on-rule-change="false"
      >
        <el-row :gutter="24">
          <!--Tên phòng-->
          <el-col :span="24" class="margin-bottom-10">
            <el-form-item label="Tên phòng: " prop="roomName">
              <el-input
                v-model="form.roomName"
                show-word-limit
                placeholder="Tên phòng"
                class="input-border__bottom input-border__radius__0 style-fullWidth input-count__bottom"
                size="medium"
                maxlength="255"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row
          :gutter="24"
          v-if="form.type === TYPE.ONLINE_MOBIMEETING_CODINH"
        >
          <el-col :span="24" class="margin-bottom-10">
            <el-form-item label="Mã phòng họp" prop="roomCode">
              <el-input
                v-model="form.roomCode"
                placeholder="Mã phòng họp"
                class="input-border__bottom input-border__radius__0 style-fullWidth input-count__bottom"
                size="medium"
                maxlength="50"
                show-word-limit
                @change="roomCodeChanged"
              >
                <i
                  slot="suffix"
                  class="fas fa-external-link-alt clickable"
                  title="Kiểm tra"
                  @click="checkRoomCode"
                ></i>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row
          :gutter="24"
          v-if="form.type === TYPE.ONLINE_MOBIMEETING_CODINH"
        >
          <el-col :span="24" class="margin-bottom-10">
            <el-form-item label="Link phòng họp" prop="url">
              <el-input
                v-model="form.url"
                placeholder="Link phòng họp"
                class="input-border__bottom input-border__radius__0 style-fullWidth input-count__bottom"
                size="medium"
                maxlength="200"
                show-word-limit
              >
                <i
                  slot="suffix"
                  class="fas fa-external-link-alt clickable"
                  title="Kiểm tra"
                  @click="checkRoomUrl"
                ></i>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!--Ghi chú-->
        <el-row :gutter="12">
          <el-col :span="24" class="margin-bottom-10">
            <el-form-item label="Ghi chú" prop="roomDesc">
              <el-input
                v-model="form.roomDesc"
                type="textarea"
                placeholder="Ghi chú"
                class="input-border__bottom input-border__radius__0 style-fullWidth input-count__bottom"
                size="medium"
                maxlength="500"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>

    <template #footer>
      <div class="flex-row form-button__action flex__left">
        <el-button
          size="medium"
          type="success"
          class="addDocs color__white bg__blue btn-none__border"
          @click="save"
        >
          <i class="far fa-check-circle font-size__small"></i>
          &nbsp;Tạo mới
        </el-button>
        <el-button
          type="info"
          size="medium"
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
          >Hủy
        </el-button>
      </div>
    </template>
  </dialogTemplate>
</template>

<script>
import dateFormatter from "../../../filters/dateFormatter";
import buildShortNameFilter from "../../../filters/buildShortNameFilter";
import hcCfgMeetingRoomCreateDialogMixin from "./hcCfgMeetingRoomCreateDialogMixin";
import constants from "../../../constants";
import meetingRoomService from "../../../services/meetingRoomService";

export default {
  filters: { buildShortNameFilter, dateFormatter },
  props: ["isOpen", "id", "deptId"],
  mixins: [hcCfgMeetingRoomCreateDialogMixin],
  components: {
    dialogTemplate: () => import("../../common/custom-dialog.vue"),
  },

  created() {
    this.initOptions();
    this.initForm();
    this.initValidationRules();
  },

  methods: {
    initForm() {
      this.form.type =
        constants.HC_CFG_MEETING_ROOM.TYPE.ONLINE_MOBIMEETING_CODINH;
    },

    convertToSubmitForm() {
      return {
        roomName: this.form.roomName,
        roomSize: this.form.roomSize,
        roomDesc: this.form.roomDesc,
        type: this.form.type,
        roomCode: this.form.roomCode,
        url: this.form.url,
        deptId: this.deptId,
      };
    },

    save_() {
      return meetingRoomService
        .createMobimeetingCoDinh(this.convertToSubmitForm())
        .then((response) => response.data);
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/setting/quanLyPhongHop/mobimeeting-codinh-room-create-dialog.vue